import React from "react";
import { useDispatch } from "react-redux";
import { userPreviewingContentAction } from "modules/content";
import { Class } from "services/graphql";
import Icon, { Play, ExternalLink } from "app/components/Icon";
import PlayerWithControls from "app/components/ResponsiveVideoPlayer/PlayerWithControls";
import Flex from "app/components/Flex";
import { useCanUserTakeClass } from "hooks/Classes";
import { CtaButton } from "./styles";
import styles from "./PreviewPlayer.module.scss";

interface Props {
  classData: Class;
  goToClass(): void;
}

export function PreviewPlayer({ classData, goToClass }: Props) {
  const { canUserTakeClass } = useCanUserTakeClass({ classId: classData.id });
  const dispatch = useDispatch();

  if (!classData) {
    return null;
  }

  return (
    <PlayerWithControls
      playsinline
      forceMute={classData.isPreviewVideoMuted}
      url={classData.preview_url}
      onProgress={(videoProgress: any) => {
        dispatch(
          userPreviewingContentAction({
            contentData: classData,
            component: "PreviewPlayer",
            previewDuration: Math.floor(videoProgress.playedSeconds),
          })
        );
      }}
      CtaComponents={() => (
        <CtaButton onClick={goToClass}>
          <Icon as={Play} width="25px" height="25px" className={styles.icon} />
          {canUserTakeClass ? "Start" : "Upgrade to Start"}
        </CtaButton>
      )}
      AlertComponent={() =>
        classData.isPreviewVideoMuted &&
        classData.externalPreviewUrl && (
          <Flex>
            <button
              type="button"
              onClick={() =>
                window.open(classData.externalPreviewUrl, "_blank")
              }
              className={styles.previewButton}
            >
              <span className={styles.buttonText}>Preview with Music</span>
              <Icon
                as={ExternalLink}
                width="16px"
                height="16px"
                className={styles.icon}
              />
            </button>
          </Flex>
        )
      }
      loop
      showLoader={false}
      position="absolute"
      height="100%"
      width="auto"
    />
  );
}
